// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA4_NZwhVKZdykeiPJ444NO-t0lRlgSoxY",
  authDomain: "organizer-a85f0.firebaseapp.com",
  projectId: "organizer-a85f0",
  storageBucket: "organizer-a85f0.appspot.com",
  messagingSenderId: "732216229718",
  appId: "1:732216229718:web:8bfd1bc4f31456cb4b60f7",
  measurementId: "G-CXMC2842VZ",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
